import React, { Component } from 'react';
import AdminHolidaysTable from './AdminHolidaysTable';

export class AdminHolidaysContent extends Component {
  render() {

    return (
      <AdminHolidaysTable titleTableList={this.props.titleTableList} />
    )

  }
}

export default AdminHolidaysContent


// WEBPACK FOOTER //
// ./src/components/Administration/AdminHolidays/AdminHolidaysContent.js